import { createUseStyles } from "react-jss";
import { isTV } from "../../../utils/platform";

export const useStyles = createUseStyles({
  root: {
    lineHeight: "24px",
    color: "#fff",
  },
  iconsList: {
    display: "grid",
    gap: 12,
    "& > p": {
      display: "flex",
    },
  },

  hoverEffect: {
    overflow: "unset",
    position: "relative",
    border: "2px solid transparent",
    "&:hover": {
      "&:after": {
        content: `""`,
        position: "absolute",
        inset: -2,
        padding: 2,
        ...(isTV
          ? { border: "2px solid rgba(255, 255, 255, 0.6)" }
          : {
              background:
                "linear-gradient(108.87deg, rgba(255, 255, 255, 0.8) 0.66%, rgba(211, 211, 211, 0.25) 99.48%)",
              WebkitMask:
                "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
              WebkitMaskComposite: "xor",
            }),
        borderRadius: 6,
      },
    },
  },
});
